export interface IScheduledEvent {
    id: number // Порядковый номер. НЕ МЕНЯТЬ!
    dateStart: string // Дата мероприятия
    dateEnd: string // Дата окончания мероприятия
    title: string // Заголовок мероприятия
    url: string // Внутренняя ссылка на мероприятие
    description?: string // Описание мероприятия (краткое)
    share?: string // Изображение "поделиться" для мероприятия
    record?: string // Ссылка на iframe с записью мероприятия
    hideOlineVideo?: boolean // Вообще скрыть видео
    hideOnlineVideoBeforeEnd?: boolean // Скрыть видео пока событие не завершено
    regLink?: string // Ссылка на регистрацию
}

export const EVENT_DATE_FORMAT = "DD.MM.YYYY HH:mm"

export const EVENTS : IScheduledEvent[] = [
    {
        id: 10,
        dateStart: "18.09.2025 11.00",
        dateEnd: "18.09.2025 12.00",
        title: "Презентация XSQUARE 6.0",
        url: "/20250918-xsquare-6_0",
        description: "Презентация XSQUARE 6.0 или день разработчика",
        record: "https://rutube.ru/play/embed/0bfd5ea69bf4e4d303c1766ffe48e221/",
        hideOlineVideo: false,
        hideOnlineVideoBeforeEnd: false,
        regLink: "https://my.mts-link.ru/j/127291167/99115581"
    },
    {
        id: 11,
        dateStart: "16.09.2025 17.00",
        dateEnd: "16.09.2025 18.30",
        title: "Low-code разработка на PostgreSQL с платформой XSQUARE",
        url: "/20250919-vk-cloud-conf",
        description: "",
        record: "https://vk.com/video_ext.php?oid=-164978780&id=456239743&hash=abc123def456",
        hideOlineVideo: false,
        hideOnlineVideoBeforeEnd: false,
        regLink: ""
    },
    {
        id: 8,
        dateStart: "23.04.2025 11:00",
        dateEnd: "23.04.2025 12:15",
        title: "Презентация XSQUARE 5.3",
        url: "/20250422-xsquare-5-3",
        description: "Новые возможности XSQUARE 5.3. Презентация XSQUARE - DAC for Oracle",
        record: "https://rutube.ru/play/embed/8cc1d36bd7da56b15fe639712264c3f7/ ",
        hideOlineVideo: false,
        hideOnlineVideoBeforeEnd: false,
        regLink: "https://my.mts-link.ru/j/60218051/340990314"
    },
    {
        id: 9,
        dateStart: "10.04.2025 12:20",
        dateEnd: "10.04.2025 13:10",
        title: "PG BootCamp Russia 2025 Екатеринбург",
        url: "/20250410-pg-bootcamp",
        description: "Превращаем Postgres в RESTfull API сервер.\n" +
            "Отказываемся от FWD.\n" +
            "Proxy-Server для любых СУБД.\n" +
            "Шардинг данных без ограничений по объему.",
        record: "https://rutube.ru/play/embed/0f069bbad8dfcbb1f6f96dd082cade01/",
        hideOlineVideo: false,
        hideOnlineVideoBeforeEnd: false,
        regLink: ""
    },
    {
        id: 7,
        dateStart: "08.04.2025 11:00",
        dateEnd: "08.04.2025 12:00",
        title: "Партнерская конференция",
        url: "/20250408-oracle-migration",
        description: "Рассказываем про миграцию с Oracle Apex / Oracle Forms на PostgreSQL, на XSQUARE",
        record: "",
        hideOlineVideo: true,
        hideOnlineVideoBeforeEnd: false,
        regLink: "https://my.mts-link.ru/j/127291167/1788752473"
    },
    {
        id: 5,
        dateStart: "01.11.2024 16:00",
        dateEnd: "01.11.2024 17:00",
        title: "Презентация новой версии XSQUARE 5.0",
        url: "/20241029-clone-oracle-apex",
        description: "",
        record: "https://rutube.ru/play/embed/989aaa8850640fabd97ee8cfa90bbc43/",
        hideOlineVideo: false,
        hideOnlineVideoBeforeEnd: false
    },
    {
        id: 4,
        dateStart: "24.09.2024 11:00",
        dateEnd: "24.09.2024 14:00",
        title: "XSQUARE на ARM / e2k / Loongson",
        url: "/20240924-xsquare-arm-e2k",
        description: "Микроэлектронника 2024",
        record: "",
        hideOlineVideo: true,
        hideOnlineVideoBeforeEnd: false,
        regLink: ""
    },
    {
        id: 6,
        dateStart: "19.09.2024 11:00",
        dateEnd: "19.09.2024 12:00",
        title: "Pangolin Day",
        url: "/20250331-pangolin-conf",
        description: "Pangolin Day — первая IT-конференция от команды разработки Platform V Pangolin",
        record: "https://rutube.ru/play/embed/f1d51c4efead3c9e8b63dc2bb7f0e448/",
        hideOlineVideo: false,
        hideOnlineVideoBeforeEnd: false,
        regLink: ""
    },
    {
        id: 3,
        dateStart: "17.09.2024 12:00",
        dateEnd: "17.09.2024 14:00",
        title: "PostgreSQL как сервер приложений, или low-code на Postgres",
        url: "/20240917-psql-low-code",
        description: "PGBootCamp Inititative event. Took place in Kazan",
        record: "",
        hideOlineVideo: true,
        hideOnlineVideoBeforeEnd: false,
        regLink: "https://pgbootcamp.ru/ru/2024-kazan"
    },
    {
        id: 2,
        dateStart: "09.04.2024 11:00",
        dateEnd: "09.04.2024 14:00",
        title: "Pgconf.2024",
        url: "/20240409-pghconf-2024",
        description: "Миграция с Oracle APEX/Forms на Эльбрус e2k. Проблемы. Производительность",
        record: "",
        hideOlineVideo: true,
        hideOnlineVideoBeforeEnd: false,
        regLink: "https://pgconf.ru/talk/1589547"
    },
    {
        id: 1,
        dateStart: "01.02.2024 11:00",
        dateEnd: "01.02.2024 12:00",
        title: "Презентация XSQUARE 4.0",
        url: "/20240201-xsquare-4-0",
        description: "Презентация новой версии XSQUARE",
        record: "",
        hideOlineVideo: true,
        hideOnlineVideoBeforeEnd: false,
        regLink: ""
    },
    {
        id: 0,
        dateStart: "28.06.2023 11:00",
        dateEnd: "28.06.2023 12:00",
        title: "Презентация XSQUARE 3.0",
        url: "/20230628-xsquare-3-0",
        description: "Презентация новой версии XSQUARE – PGHS/XRAD",
        record: "",
        hideOlineVideo: true,
        hideOnlineVideoBeforeEnd: false,
        regLink: ""
    },
]

